import { dateFormatter, setStylesOnElement } from "../../util/Misc";
import {headerRender} from "../templates/renders/header";

/**
 * Creates a custom element that will display as a header for every async conversation
 * @type {{template, isYestarday(*): *, created(): void, isToday(*): *, tagName: string, render(*): void}}
 */
const HeaderView: any = {
    tagName: "header-view",
    initialize(options) {
        initComponent(options);
    },
    renderer: headerRender,
    created() {
        this.cont = this.el.firstChild;
        this.header = this.cont.querySelector(".header");
        this.text = this.header.firstElementChild;

        setStylesOnElement(this.headerStyleProps, this.cont);
    },

    /**
     * render header text , parses the message timestamp to give date time format
     * @param {Message} message
     */
    render(message) {
        window.raf(() => {
            let dateText;
            const ts = parseInt(message.getTimeStamp(), 10);
            const d = new Date(ts);

            if (this.isToday(d)) {
                dateText = "Today";
            } else if (this.isYestarday(d)) {
                dateText = "Yesterday";
            } else {
                dateText = dateFormatter(ts, this.headerFormat);
            }

            this.text.innerText = dateText;

            if (this.sepHeader) {
                this.header.classList.add("seperator");
            }
        });
    },
    isToday(td) {
        const d = new Date();
        return td.getDate() === d.getDate() && td.getMonth() === d.getMonth() && td.getFullYear() === d.getFullYear();
    },
    isYestarday(td) {
        const d = new Date();
        return td.getDate() === d.getDate() - 1 && td.getMonth() === d.getMonth() && td.getFullYear() === d.getFullYear();
    },
};

/**
 * @export HeaderView
 * @param {CIApp} appInstance
 * @return {{template, isYestarday, (*): *, created, (): void, isToday, (*): *, tagName: string, render, (*): void}}
 */
export default appInstance => {
    HeaderView.$app = appInstance;
    const constObj: any = {};
    HeaderView.constants = constObj;

    return HeaderView;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const config = appInstance.getUIConfig();
    const constObj: any = options.constants;

    const styleConfig: any = {};
    let headerStyleProps;

    if (config.transcriptConfig) {
        const tConfig = config.transcriptConfig;
        constObj.style = tConfig.headerViewStyles;
        headerStyleProps = config.transcriptConfig.headerStyleProperties || {};
        constObj.sepHeader = config.appConfigProps && config.appConfigProps.showSeperatorHeader;
        constObj.headerFormat = (config.appConfigProps && config.appConfigProps.headerTimeFormat) || "month, dd yyyy";
    } else {
        headerStyleProps = {};
    }

    styleConfig.marginLeft = `${headerStyleProps.headerLeftMargin || 0}px`;
    styleConfig.marginBottom = `${headerStyleProps.headerBottomMargin || 15}px`;
    styleConfig.marginRight = `${headerStyleProps.headerRightMargin || 5}px`;
    styleConfig.marginTop = `${headerStyleProps.headerTopMargin || 0}px`;

    constObj.headerStyleProps = styleConfig;
};
